let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4SAm0")).then(() => parcelRequire('2uiq7'));